const GET_FLEET_DISPOSITION_LOCATION_SAVE = "GET_FLEET_DISPOSITION_LOCATION_SAVE"
const SET_FLEET_DISPOSITION_LOCATION_SAVE = "SET_FLEET_DISPOSITION_LOCATION_SAVE"

export{
    GET_FLEET_DISPOSITION_LOCATION_SAVE,
    SET_FLEET_DISPOSITION_LOCATION_SAVE
}